<script>
import Icon from '@wielink-application/shared/vue/components/form/horizontal/icon.vue'
export default Icon;
</script>